import React from "react";
import { StyledButton } from "./Styled";

const LoginButton = (props) => {
  return <StyledButton {...props}>Sign in</StyledButton>;
};

export default LoginButton;
